import axios from "axios";

export async function fetchTex(id: string) {
    return await axios.get(`/Tex/Get?id=${id}`);
}